import {
  Component,
  EventEmitter,
  HostListener,
  inject,
  Input,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import { ClientSwitcherDropdownComponent } from '@components';
import { AppHeaderService, StudyService, UserDataService } from '@services';
import { MenuStateService } from 'app/services/menu-state/menu-state.service';

@Component({
  selector: 'app-header',
  templateUrl: './app-header.component.html',
  styleUrls: ['./app-header.component.scss']
})
export class AppHeaderComponent implements OnInit {
  @Input() showSponsorDropdown = true;
  @Input() sponsors: string[] = [];
  @Input() selectedSponsor = 'All';

  @Output() sponsorApplyClicked = new EventEmitter<string>();
  @Output() profileClicked = new EventEmitter<HTMLElement>();

  private userDataService = inject(UserDataService);
  private appHeaderService: AppHeaderService = inject(AppHeaderService);
  private studyService: StudyService = inject(StudyService);
  public menuStateService = inject(MenuStateService);

  moreThanOneSponsor = false;
  switchOpen = false;
  pendingSponsor = '';

  ngOnInit(): void {
    // Initialize sponsors from service if not provided via Input
    if (this.sponsors.length === 0) {
      this.sponsors = this.studyService.getClientNamesList();
    }

    // Initialize selectedSponsor from session storage if not provided
    const storedSponsor = sessionStorage.getItem('sponsorSelected');
    if (storedSponsor && this.selectedSponsor === 'All') {
      this.selectedSponsor = storedSponsor;
    }

    this.moreThanOneSponsor = this.sponsors.length > 1;

    this.appHeaderService.updateHeaderState({
      showSponsorDropdown: this.moreThanOneSponsor,
      sponsors: this.sponsors,
      selectedSponsor: this.selectedSponsor
    });
  }

  @ViewChild('sponsorDd') sponsorDd!: ClientSwitcherDropdownComponent;

  get userEmail(): string {
    return this.userDataService.getUsername() ?? '';
  }

  onSponsorApply(sponsor: string): void {
    // Open confirmation modal
    this.pendingSponsor = sponsor;
    this.switchOpen = true;
  }

  onProfileClick(event: Event): void {
    event.stopPropagation();
    this.menuStateService.showMenu();
    const button = event.currentTarget as HTMLElement;
    this.profileClicked.emit(button);
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event): void {
    if (!this.menuStateService.isMenuVisible()) return;

    const target = event.target as HTMLElement;
    const composedPath = event.composedPath ? event.composedPath() : [];

    // Check if click is within logout overlay
    const logoutOverlay = document.querySelector('.logout-overlay-panel');
    if (logoutOverlay && (logoutOverlay.contains(target) || composedPath.includes(logoutOverlay))) {
      return;
    }

    // If we get here, click is outside both button and logout, so deactivate
    this.menuStateService.hideMenu();
  }

  onSponsorSwitchModalClosed(modalSelection: 'yes' | 'no' | 'cancel') {
    this.switchOpen = false;
    if (modalSelection === 'yes') {
      this.selectedSponsor = this.pendingSponsor;

      // Update header state
      this.appHeaderService.updateHeaderState({
        selectedSponsor: this.pendingSponsor
      });

      // Save to session storage
      sessionStorage.setItem('sponsorSelected', this.pendingSponsor);

      // Emit event to parent component
      this.sponsorApplyClicked.emit(this.pendingSponsor);
    }

    this.sponsorDd?.close();
  }
}
